import { Injectable, Injector } from '@angular/core';
// import { NgxIndexedDBService } from 'ngx-indexed-db';
import Dexie from 'dexie';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';

class DigitalEyesDb extends Dexie {

  public AddressPhotoFilesDetails: Dexie.Table;
  public InspectionFilesDetails: Dexie.Table; // id is number in this case
  public InspectionTaskDetails: Dexie.Table;
  public MetaFileDetails: Dexie.Table;
  public ChecklistDetail: Dexie.Table;
  public TaskChecklistDetail: Dexie.Table;
  public privateDetectTable: Dexie.Table;

  public: Dexie.Table;
  public constructor() {
    super("DigitalEyesDb");
    try {
      this.version(1).stores({
        AddressPhotoFilesDetails: "++AddressFileId,AddressProofImg,taskId,UserID,zoneDetails,FileType,LocalFileUrl,FileSize,FileName,UploadStatus,RetryHitting,MetaData,ServerFileID,ServerFileName,LiveUrl",
      });
      this.AddressPhotoFilesDetails = this.table("AddressPhotoFilesDetails");
    } catch (error) {
    }
  }


}

class VideoRecDb extends Dexie {
  meta!: Dexie.Table<any, string>;
  chunks!: Dexie.Table<any, number>;
  constructor() {
    super('DigitalEyesVideoDb');
    this.version(1).stores({ meta: 'id,taskId,startedAt', chunks: '++key,id' });
  }
}
@Injectable({
  providedIn: 'root'
})
export class IdbService {
  db: any;
  idbservice: any;
  componentName: string = 'idb-service';
  private videoDb = new VideoRecDb();
  constructor(private injector: Injector) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }
  async truncateData() {
    this.db = new DigitalEyesDb();
    await this.db.AddressPhotoFilesDetails.clear();
  }
  async addressVerificationFilesDetails(obj) {
    this.db = new DigitalEyesDb();
    const id = await this.db.AddressPhotoFilesDetails.add(obj);
  }
  // Address upload
  async getAddressTaskFileDetailsToUpload(taskId = null) {
    this.db = new DigitalEyesDb();
    return await this.db.AddressPhotoFilesDetails.where("taskId").equals(taskId).and(item => item.UploadStatus == 'false').toArray();
  }
  updateAddressFileDetails(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    var LocalFileUrl = InspectionFile.LocalFileUrl;
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? 'true' : 'false';
    var LocalFileUrl = uploadStatus == 'true' ? '' : InspectionFile.LocalFileUrl;

    this.db.AddressPhotoFilesDetails.update(InspectionFile.AddressFileId, { UploadStatus: uploadStatus, LocalFileUrl: LocalFileUrl, ServerFileName: uploadFileDetails.Data[0].fileName }).then(function (updated) {
      if (updated) {
        return true;
      }
      else {
        console.log("FileID not found. Nothing was updated");
        return false;
      }
    });
  }

  async updateAddressFileDetailsErrorCase(InspectionFile: any, status: any) {
    await this.db.AddressPhotoFilesDetails.update(InspectionFile.AddressFileId, { UploadStatus: status }).then(function (updated: any) {
    });
  }

  async videoRecBegin(meta: any) { 
    await this.videoDb.meta.put(meta); 
  }

  async videoRecAppend(id: string, seq: number, blob: Blob) { 
    await this.videoDb.chunks.add({ id, seq, blob }); 
  }

  async videoRecListMeta(taskId: string) { 
    return this.videoDb.meta.where('taskId').equals(taskId).toArray(); 
  }

  async videoRecReadBlob(id: string, mime: string): Promise<Blob | null> {
    const rows = await this.videoDb.chunks.where('id').equals(id).sortBy('seq');
    return rows.length ? new Blob(rows.map(r => r.blob), { type: mime }) : null;
  }

  async videoRecClear(id: string) {
    await this.videoDb.transaction('rw', this.videoDb.meta, this.videoDb.chunks, async () => {
      await this.videoDb.meta.delete(id);
      await this.videoDb.chunks.where('id').equals(id).delete();
    });
  }
  
  async videoRecPruneOld(maxAgeMs: number) {
    const old = await this.videoDb.meta.where('startedAt').below(Date.now() - maxAgeMs).primaryKeys();
    for (const id of old) await this.videoRecClear(id as string);
  }
}
